<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title" id="_idParaDest-1">Deep as the Marrow</p>
<p class="ORIM-Author-Name">F. Paul Wilson</p>
<p class="ORIM-Author-Name"><img alt="image" src="image/logo3.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DeepAsTheMarrow1.vue?4f37a87e